<template>
    <div>
        <ds-list-item
            v-for="item in listItems"
            :key="item.id"
            #title
            clickable
            target="_blank"
            @click="handleClick(item)"
        >
            <ds-avatar :name="item.id.toString()" /> {{ item.label }}
        </ds-list-item>
    </div>
</template>


<script>

import amplitude from '@/components/util/analytics/amplitude';

const HELP_ARTICLE_LINKS_CLASSIC = [
    {
        id: 1,
        link: 'https://learn.thryv.com/hc/en-us/articles/37241726237069-Why-Domain-Authentication-is-Required-with-Keap',
        label: 'Ensure DKIM is set',
    },
    {
        id: 2,
        link: 'https://learn.thryv.com/hc/en-us/articles/41630564193805-Engagement-Essentials-Understanding-Email-Engagement-and-Why-It-Matters-with-Keap',
        label: 'Review email engagement essentials',
    },
    {
        id: 3,
        link: 'https://learn.thryv.com/hc/en-us/articles/41637399074061-Tag-Contacts-Unengaged-Up-to-30-Days-for-a-Re-engagement-Campaign-with-Keap',
        label: 'Tag unengaged contacts',
    },
    {
        id: 4,
        link: 'https://learn.thryv.com/hc/en-us/articles/37443318628621-How-to-Avoid-Content-Filters-In-Email-Marketing-with-Keap',
        label: 'Review your email content',
    },
    {
        id: 5,
        link: 'https://learn.thryv.com/hc/en-us/articles/41638117123213-Send-a-Re-engagement-Email-to-your-Unengaged-Contacts-with-Keap',
        label: 'Start re-engagement campaign (for low engagement)',
    },
    {
        id: 6,
        link: 'https://learn.thryv.com/hc/en-us/articles/41630277888013-Automated-List-Management-with-Keap',
        label: 'Set List Automation',
    }
];

const HELP_ARTICLE_LINKS_KEAP = [
    {
        id: 1,
        link: 'https://learn.thryv.com/hc/en-us/articles/37241726237069-Why-Domain-Authentication-is-Required-with-Keap',
        label: 'Ensure DKIM is set',
    },
    {
        id: 2,
        link: 'https://learn.thryv.com/hc/en-us/articles/41630564193805-Engagement-Essentials-Understanding-Email-Engagement-and-Why-It-Matters-with-Keap',
        label: 'Review email engagement essentials',
    },
    {
        id: 3,
        link: 'https://learn.thryv.com/hc/en-us/articles/41637399074061-Tag-Contacts-Unengaged-Up-to-30-Days-for-a-Re-engagement-Campaign-with-Keap',
        label: 'Tag unengaged contacts',
    },
    {
        id: 4,
        link: 'https://learn.thryv.com/hc/en-us/articles/37443318628621-How-to-Avoid-Content-Filters-In-Email-Marketing-with-Keap',
        label: 'Review your email content',
    },
    {
        id: 5,
        link: 'https://learn.thryv.com/hc/en-us/articles/41638117123213-Send-a-Re-engagement-Email-to-your-Unengaged-Contacts-with-Keap',
        label: 'Start re-engagement campaign (for low engagement)',
    },
];

export default {
    props: {
        isUpdateHelpArticleLinksEnabled: {
            type: Boolean,
            default: false,
        },
        isUnengagedEmailStatusProcessingEnabled: Boolean,
        appEdition: String,
    },
    computed: {
        listItems() {
            const isClassic = this.appEdition === 'Keap Max Classic Edition';

            if (isClassic) {
                return HELP_ARTICLE_LINKS_CLASSIC;
            }

            return HELP_ARTICLE_LINKS_KEAP;
        },
    },

    methods: {
        handleClick(object) {
            window.open(object.link, '_blank');

            this.emitAmplitudeEvent(object.label);
        },

        emitAmplitudeEvent(event) {
            amplitude.infusionsoft.track('Email Analytics - CTA / Help', {
                'Event Source': 'Email Analytics Engagement Page',
                Destination: event,
            });
        },
    },


};

</script>

<style lang="scss" scoped>

#leadingSlot {
    padding: 0;
}

.list-item-description {
    font-size: $font-size-md;
    padding-right: $spacing-200;
}

.row {
    display: flex;
}

.column-left {
    flex: 50%;
    float: left;
}

.column-right {
    flex: 50%;
    text-align: right;
}

</style>
